import { PlanOptionCard } from '../../new-elite-landing/components/NewEliteLandingPlanSelector'
import type { ElitePlansAdvisorySelection } from '../hooks/useElitePlansAdvisorySelection'
import { ElitePlansEventId, trackElitePlansClick } from '../analytics'

type ElitePlansTenureSelectorProps = {
  advisory: ElitePlansAdvisorySelection
  planId: string
}

export function ElitePlansTenureSelector({ advisory, planId }: ElitePlansTenureSelectorProps) {
  if (!advisory.showPlanSection || advisory.visiblePlanConfigs.length === 0) {
    return null
  }

  return (
    <div className='mt-6 w-full space-y-3 text-left' data-testid='elite-plans-tenure-section'>
      {advisory.planSectionTitle ? (
        <div className='flex items-center gap-3'>
          <div className='h-px flex-1 bg-[color:var(--ep-ink-muted)] opacity-20' />
          <p className='text-[13px] font-medium leading-[1.2] tracking-[0.03em] text-[color:var(--ep-ink-muted)]'>
            {advisory.planSectionTitle}
          </p>
          <div className='h-px flex-1 bg-[color:var(--ep-ink-muted)] opacity-20' />
        </div>
      ) : null}

      {advisory.visiblePlanConfigs.map((plan) => (
        <PlanOptionCard
          key={plan.id}
          familyConfig={advisory.familyConfig}
          plan={plan}
          isSelected={advisory.selectedTenure === plan.type}
          onClick={() => {
            if (advisory.suppressPlanChrome) return
            trackElitePlansClick(ElitePlansEventId.PlanTenureToggle, {
              planId,
              buttonLabel: plan.type,
              landingPageState: advisory.landingPageState ?? ''
            })
            advisory.setSelectedTenure(plan.type)
          }}
          topLabel={advisory.topLabel}
          suppressPlanChrome={advisory.suppressPlanChrome}
          paymentSuccessTopBanner={advisory.paymentSuccessTopBanner}
          pendingPaymentTopLabelClock={advisory.pendingPaymentTopLabelClock}
          customYearlyBannerLabel={advisory.renewExtraMonthsBannerLabel}
          singleVisiblePlan={advisory.singleVisiblePlan}
        />
      ))}
    </div>
  )
}
